module.exports = __webpack_public_path__ + "img/casiers.b25cdd71.png";